import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t-2 border-ink mt-24 bg-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <h2 className="font-display font-extrabold text-3xl leading-none tracking-tighter">
              AI YAI YAI<span className="text-brorange">!</span>
            </h2>
            <p className="eyebrow text-white/50 mt-2">LOOK WHAT AI IS DOING TO BUSINESS.</p>
            <p className="text-sm text-white/60 mt-4 max-w-xs leading-relaxed">
              Real examples of businesses materially transformed by AI. Evidence first — every case keeps its original source.
            </p>
          </div>
          <div>
            <p className="eyebrow text-white/40 mb-3">Explore</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-bryellow transition-colors">Discover</Link></li>
              <li><Link to="/trends" className="hover:text-bryellow transition-colors">Trends</Link></li>
              <li><Link to="/saved" className="hover:text-bryellow transition-colors">Saved</Link></li>
              <li><Link to="/about" className="hover:text-bryellow transition-colors">About</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow text-white/40 mb-3">The editorial rule</p>
            <p className="text-sm text-white/70 leading-relaxed">
              We only feature cases where AI materially changed a process, product, service or business model —
              not simply where someone started using an AI tool. Reported results are attributed to their source and
              not necessarily independently verified.
            </p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} AI YAI YAI · aiyaiyai.tech</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Editorial admin</Link>
        </div>
      </div>
    </footer>
  );
}
